var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.105 73.0526C134.105 106.769 106.769 134.105 73.0526 134.105C39.3363 134.105 12 106.769 12 73.0526C12 39.3363 39.3363 12 73.0526 12C106.769 12 134.105 39.3363 134.105 73.0526Z",
    fill: "#FECD50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9847 48.5553L97.659 51.2593L77.6288 71.2263L75.8527 72.9969L77.6288 74.7674L97.659 94.7344L94.9847 97.4384L74.8997 77.4798L73.1376 75.7287L71.3754 77.4798L51.2806 97.4482L48.5599 94.7275L68.6435 74.7702L70.428 72.9969L68.6435 71.2235L48.5599 51.2663L51.2806 48.5456L71.3754 68.514L73.1376 70.2651L74.8997 68.514L94.9847 48.5553Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/paymentFailed.1c44ac9c3e6eff2eed65ef6281f52b26.svg";
export { ForwardRef as ReactComponent };